// extracted by mini-css-extract-plugin
export var chevronIcon = "_59-2";
export var teamName = "_59-1";
export var teamSwitcherButton = "_59-0";